import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const ReactModal = ({ title, subtitle, children, extraClasses, onClose }) => {
  const modalContentRef = useRef(null);

  useEffect(() => {
    // Close modal when the user clicks outside or press ESC key
    const closeOnEscapeKey = e => e.keyCode === 27 ? onClose() : null;
    const handleClickOutside = event => {
      if (modalContentRef.current && !modalContentRef.current.contains(event.target)) {
        onClose();
      }
    };
    document.body.classList.add('react-modal-open');
    document.addEventListener('keydown', closeOnEscapeKey);
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.body.classList.remove('react-modal-open');
      document.removeEventListener('keydown', closeOnEscapeKey);
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const getClasses = () => {
    let classes = 'react-modal-content ';
    if (extraClasses !== '') {
      classes += extraClasses;
    }
    return classes;
  };

  const renderHeader = () => {
    return (
      <>
        <div className='content-header'>
          <div className='container-title'>
          <div>{title && <h2 className='left ib title mb-5'>{title}</h2>}</div>
          <div>
          </div>
            <a onClick={onClose} className='right close'>
            <i className='fa fa-times fa-2x' />
            </a></div>
          <div className= "subtitle-style">
            {subtitle && <h2 className='left ib w3 t3 mb-10'>{subtitle}</h2>}

          </div>
        </div >
      </>
    );
  };

  return ReactDOM.createPortal(
    <div className='react-modal-wrapper'>
      <div ref={modalContentRef} className={getClasses()}>
        {renderHeader()}
        {children}
      </div>
    </div>,
    document.querySelector('#body')
  );
};

ReactModal.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  children: PropTypes.element.isRequired,
  extraClasses: PropTypes.string,
  onClose: PropTypes.func.isRequired
};

export default ReactModal;
